'use client';

import { createTheme } from '@mui/material';

import { colors } from './colors';
import { nextTheme } from './nextTheme';

export const tableTheme = createTheme({
  ...nextTheme,
  components: {
    MuiTable: {
      styleOverrides: {
        root: {
          width: '100%',
          backgroundColor: colors.smokyWhite,
          padding: '12px 0 8px',
        },
      },
    },
    MuiTableContainer: {
      styleOverrides: {
        root: {
          display: 'flex',
          '&:after': {
            position: 'absolute',
            right: 0,
            content: "''",
            width: 48,
            height: '100%',
            background: `linear-gradient(270deg, ${colors.smokyWhite} 0%, transparent 100%)`,
            flexShrink: 0,
          },
        },
      },
    },
    MuiTableHead: {
      styleOverrides: {
        root: {
          opacity: '1 !important',
          backgroundColor: colors.smokyWhite,
          paddingRight: 24,
          display: 'grid',

          '& th .MuiButtonBase-root': {
            '&:hover .MuiSvgIcon-root': {
              opacity: 0.5,
            },
            '&.Mui-active .MuiSvgIcon-root': {
              opacity: 1,
            },
            '& .MuiSvgIcon-root': {
              opacity: 0.3,
            },
          },
        },
      },
    },
    MuiTableBody: {
      styleOverrides: {
        root: {
          display: 'grid',
          paddingRight: 24,
        },
      },
    },
    MuiTableRow: {
      styleOverrides: {
        root: {
          '& .MuiTableCell-head': {
            backgroundColor: colors.smokyWhite,
          },
          '& .MuiTableCell-root': {
            backgroundColor: colors.smokyWhite,
          },
          '&:hover .MuiTableCell-root': {
            backgroundColor: colors.smokyWhite,
          },
          '&.MuiTableRow-root:last-of-type .MuiTableCell-body': {
            borderColor: 'transparent',
          },
        },
      },
    },
    MuiTableCell: {
      styleOverrides: {
        root: {
          color: colors.black,
          fontSize: 16,
          '&.MuiTableCell-head': {
            height: 64,
            color: colors.blackOpacity[40],
            fontSize: 12,
            fontWeight: 400,
            boxShadow: 'none',
            paddingTop: 0,

            '&:first-child': {
              paddingLeft: 16,
            },
            '&:last-child': {
              paddingRight: 32,
            },
          },
          '&.MuiTableCell-body': {
            minHeight: 54,
            fontFamily: nextTheme.typography.secondaryFontFamily,
            letterSpacing: 0.25,
            boxShadow: 'none',
            borderColor: colors.blackOpacity[4],

            '&:first-child': {
              paddingLeft: 16,
            },
            '&:last-child': {
              paddingRight: 32,
            },
          },
        },
        body: {
          boxShadow: 'none',
        },
        head: {
          boxShadow: 'none',
          borderBottom: 0,
        },
      },
    },
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          padding: '4px 8px 4px 8px',
          background: colors.blackOpacity[8],
          backdropFilter: 'blur(20px)',
          borderRadius: 4,
          color: colors.black,
        },
        arrow: {
          display: 'none',
        },
      },
    },
    MuiToolbar: {
      styleOverrides: {
        root: {
          '&.MuiToolbar-gutters': {
            background: colors.smokyWhite,
            color: colors.black,
            zIndex: 2,
            minHeight: 52,
            boxShadow: 'none',
          },
        },
      },
    },
    MuiTablePagination: {
      styleOverrides: {
        root: {
          '@media (max-width: 500px)': {
            '& .MuiTablePagination-toolbar': {
              justifyContent: 'center',
              flexWrap: 'wrap',
              padding: 0,

              '& .MuiTablePagination-actions': {
                marginLeft: 0,
              },
            },
          },
        },
      },
    },
  },
});
